import React from 'react'
import { Dropdown } from "@/components/ui/modal";
import { useTranslation } from "react-i18next";
import { Search, X } from "lucide-react";
import { VOICE_OPTIONS } from "@/manager/manager/creation-audio-filter-options-manager";


interface VoiceSearchFormProps {
  searchName: string;
  condition: string;
  filters: Record<string, string>;
  filterOptions: Record<string, { label: string; value: string }[]>;
  onSearchNameChange: (value: string) => void;
  onConditionChange: (value: string) => void;
  onFilterChange: (key: string, value: string) => void;
}

/** 音频搜索表单 */
export const AudioSearchForm: React.FC<VoiceSearchFormProps> = (props) => {
  const {
    searchName,
    condition,
    filters,
    filterOptions,
    onSearchNameChange,
    onConditionChange,
    onFilterChange,
  } = props;

  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center mb-4 gap-x-3 gap-y-2">
      {/* 搜索输入框 */}
      <div className="relative w-[33rem] h-10">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="text"
          placeholder={t("modal_audio.audio_table.search_name")}
          value={searchName}
          onChange={(e) => onSearchNameChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-i-input-border hover:shadow-[0px_0px_0px_4px_rgba(242,244,247,1)] focus:border-i-input-border-focus rounded-sm text-base placeholder:text-i-placeholder focus:outline-none"
        />
        {searchName && (
          <button
            type="button"
            onClick={() => onSearchNameChange("")}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4"
            title={t("modal_audio.audio_table.clear_search")}
          >
            <X className="w-4 h-4 text-i-placeholder" />
          </button>
        )}
      </div>
      <Dropdown
        value={condition}
        options={VOICE_OPTIONS.map((item) => ({
          label: t(item.label),
          value: item.value,
        }))}
        width="10.5rem"
        className="text-xs border-[rgb(208,213,221)]"
        onValueChange={(v) => onConditionChange(v)}
      />
      {condition !== 'my_voices' && Object.entries(filterOptions).map(([key, value]) => (
        <Dropdown
          key={key}
          defaultValue="all"
          value={filters[key] || "all"}
          options={value.map((item) => ({
            label: t(item.label),
            value: item.value,
          }))}
          showClearButton
          width="10.5rem"
          className="text-xs border-[rgb(208,213,221)]"
          onValueChange={(value) => onFilterChange(key, value)}
        />
      ))}
    </div>
  )
}
